import { render } from "./CVView.vue?vue&type=template&id=bbdcb6ea"
import script from "./CVView.vue?vue&type=script&lang=js"
export * from "./CVView.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__